import HashtagBackground from './HashtagBackground';

export default HashtagBackground;
